import React from 'react';
import { Button, Grid, FormControl, InputLabel, MenuItem, Select, TextField, Chip } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles'
import NavBar from '../components/navbar'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const skills_btns = [
    'ML Engineer',
    'ML Researcher',
    'Data Scientist',
    'Software Engineer',
    'Data Engineer',
    'Data Analyst'
]

const industries = [
    'Education',
    'Healthcare and medicine',
    'Marketing',
    'Public relations',
    'Recruitment',
    'Retail and e-commerce',
    'Small business',
    'Software',
    'Others'
]

const ColorButton = withStyles((theme) => ({
    root: {
        color: 'white',
        backgroundColor: '#153BAB',
        width: '180px',
        height: '45px',
        borderRadius: '10px',
        marginLeft: '15px',
        marginTop: '30px',
        marginBottom: '30px',
        '&:hover': {
            backgroundColor: '#294780',
        },
    },
}))(Button);

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: '100%',
    },
    bgBlue: {
        backgroundColor: '#153BAB',
        color: 'white',
        width: "100%"
    },
    grey: {
        color: '#414041',
        width: "100%"

    },

    btngrey: {
        backgroundColor: '#414041',
        color:"white",
        width: "100%"

    },
    blue: {
        color: '#153BAB'
    },
    title: {
        marginTop: '50px',
        marginBottom: '25px',
        marginLeft: '50px'
    },
    select: {
        width: '90%'
    }
}))

const GreySpan = ({ children }) => {
    const classes = useStyles();
    return <span className={classes.grey}>{children}</span>
}

const BlueSpan = ({ children }) => {
    const classes = useStyles();
    return <span className={classes.blue}>{children}</span>
}

const InputForm = (props) => {
    const classes = useStyles()
    const [select, setSelect] = React.useState([false, false, false, false, false, false])
    const [expertise, setExpertise] = React.useState("");
    const [industry, setIndustry] = React.useState("");
    const [skills, setSkills] = React.useState([]);
    const [skill, setSkill] = React.useState('');
    const [hireType, setHireType] = React.useState();
    const [refresh, setRefresh] = React.useState(false)
    const [open, setOpen] = React.useState(false);
    const [open2, setOpen2] = React.useState(false);

    const [email, setEmail] = React.useState('');
    const [name, setName] = React.useState('');
    const [company, setCompany] = React.useState('');
    const [title, setTitle] = React.useState('');
    const [phone, setPhone] = React.useState('');



    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setOpen2(true);

        // handleSubmit();
    };


    const handleClose2= () => {
        setOpen2(false);
        // handleSubmit();
    };
    const handleSelect = (index) => {
        let list = select;
        list[index] = !list[index];
        setSelect(list);
        console.log(select);
        setRefresh(true)
    }

    const handleExpertiseChange = (event) => {
        setExpertise(event.target.value);
    }

    const handleIndustryChange = (event) => {
        setIndustry(event.target.value);
    }

    const handleSkillChange = (event) => {
        const data = event.target.value
        setSkill(event.target.value);

        if (data.slice(-1) === ',') {
            setSkills([...skills, skill])
            setSkill('')
            console.log(skills)
        }
    }

    const handleDeleteSkill = (index) => {
        let arr = skills;
        arr.splice(index, 1)
        setSkills(arr)
        setRefresh(true)
    }

    const handleFullTime = () => {
        if (hireType === 'fulltime') {
            setHireType();
        } else {
            setHireType('fulltime')
        }
    }

    const handlePartTime = () => {
        if (hireType === 'parttime') {
            setHireType();
        } else {
            setHireType('parttime')
        }
    }

    const handleSubmit = () => {
        let jobs = []
        select.forEach((item, index) => {
            if (item) {
                jobs = [...jobs, skills_btns[index]]
            }
        })

        const searchParm = {
            jobs: jobs,
            expertise: expertise,
            industry: industry,
            skills: skills,
            type: hireType,
            name: name,
            company: company,
            email: email,
            title: title,
            phone: phone
        }
        // console.log(searchParm)
        // props.history.push({
        //     pathname: '/service-result',
        //     searchParm
        // })
        console.log(searchParm)
        fetch("https://lyra-backend-product.herokuapp.com/employer/sendEmail", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            //make sure to serialize your JSON body
            body: JSON.stringify(searchParm)

        })
            .then((response) => {
                console.log(response)
            });

        handleClose();

    }

    React.useEffect(() => {
        setRefresh(false)
    }, [refresh]);

    return (
        <>
            <NavBar type='main' />
            <h1 className={classes.title}>
                <strong>
                    <GreySpan>Find  AI & Data engineers to </GreySpan>
                    <BlueSpan>hire</BlueSpan>
                </strong>
            </h1>
            <Grid container>
                <Grid item xs={12} md={6}>
                    <Grid container direction='row' justify='center' alignItems='center' spacing={2} style={{ marginLeft: '10px', paddingRight: '30px' }}>
                        <Grid item xs={10}><h5>Choose at least one skill</h5></Grid>
                        {skills_btns.map((skill, index) =>
                            <Grid item xs={6} lg={5} md={5} sm={5} key={index}>
                                <Button
                                    variant='contained'
                                    className={(select[index]) ? classes.bgBlue : null}
                                    fullWidth
                                    onHover
                                    onClick={() => handleSelect(index)}
                                >
                                    {skill}
                                </Button>

                            </Grid>

                        )}


                        <Grid item xs={10}>
                            <Button variant='contained' fullWidth className={null} onClick={handleClickOpen}>Not Sure, need help? </Button>
                            
                                 

                            <TextField
                                id="standard-basic"
                                label="What skills are you looking for?"
                                helperText="seperate skills by comma ,"
                                fullWidth
                                value={skill}
                                onChange={handleSkillChange}
                                onKeyUp={(event) => {
                                    if (event.key === 'Enter') {
                                        // console.log('Enter key pressed');
                                        // // write your functionality here
                                        // console.log(event.target.value)

                                        const data = event.target.value
                                        setSkill(data);

                                        setSkills([...skills, skill])
                                        setSkill('')
                                        console.log(skills)

                                    }
                                }
                                }
                            />
                        </Grid>
                        <Grid item xs={10}>
                            {skills.map((_skill, index) =>
                                <Chip key={index} label={_skill} onDelete={() => handleDeleteSkill(index)} style={{ marginRight: 5 }} />
                            )}

                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Grid container direction='row' justify='center' alignItems='center' spacing={5} style={{ marginTop: 0 }}>
                        <Grid item xs={9}>
                            <FormControl className={classes.formControl}>
                                <InputLabel id="expertise-label">Expertise Level?</InputLabel>
                                <Select
                                    labelId="expertise-label"
                                    id="expertise"
                                    value={expertise}
                                    onChange={handleExpertiseChange}
                                    className={classes.select}
                                >
                                    <MenuItem value={"1 - 3"}>1 - 3</MenuItem>
                                    <MenuItem value={"3 - 5"}>3 - 5</MenuItem>
                                    <MenuItem value={"5 - 7"}>5 - 7</MenuItem>
                                    <MenuItem value={"7 - 10"}>7 - 10</MenuItem>
                                    <MenuItem value={"10 - 15"}>10 - 15</MenuItem>
                                    <MenuItem value={"+15"}> +15</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={9}>
                            <FormControl className={classes.formControl}>
                                <InputLabel id="industry-label">Industry</InputLabel>
                                <Select
                                    labelId="industry-label"
                                    id="industry"
                                    value={industry}
                                    onChange={handleIndustryChange}
                                    className={classes.select}
                                >
                                    {industries.map((industry, index) =>
                                        <MenuItem key={index} value={industry}>{industry}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={4} style={{ marginTop: 25 }}>
                            <Button
                                variant='contained'
                                className={(hireType === 'fulltime') ? classes.bgBlue : null}
                                fullWidth
                                onClick={handleFullTime}
                            >
                                Full Time
                        </Button>
                        </Grid>
                        <Grid item xs={4} style={{ marginTop: 25 }}>
                            <Button
                                variant='contained'
                                className={(hireType === 'parttime') ? classes.bgBlue : null}
                                fullWidth
                                onClick={handlePartTime} >
                                Part Time
                        </Button>
                        </Grid>
                        <Grid container direction='row' justify='flex-end' alignItems='flex-end'>
                            <Grid xs={4}>
                                <ColorButton onClick={handleClickOpen}>Hire Now</ColorButton>

                            </Grid>



                        </Grid>
                    </Grid>
                </Grid>
            </Grid>


            <Dialog open={open2} onClose={handleClose2}  aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Build your Team</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                    Hire faster vetted AI & Data teams with Lyra. We are beyond happy to be a part of your growth Journey. Someone from our team will get in touch with you in the next 12 hours.


          </DialogContentText>


 
                </DialogContent>
                <DialogActions>

                    <Button onClick={handleClose2} color="primary">
                        Thanks!
                    </Button>


                </DialogActions>
            </Dialog>




            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Build your Team</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Final Step! Add your data so we can contact you.<br />We'll reach you in 48 hours.
          </DialogContentText>


                    <TextField
                        autoFocus
                        margin="dense"
                        id="emaitl"
                        label="Name"
                        // type="email"
                        fullWidth
                        onChange={e => setName(e.target.value)}

                    />

                    <TextField
                        autoFocus
                        margin="dense"
                        id="emaitl"
                        label="Email"
                        // type="email"
                        fullWidth
                        onChange={e => setEmail(e.target.value)}

                    />

                    <TextField
                        autoFocus
                        margin="dense"
                        id="emaitl"
                        label="Phone"
                        // type="email"
                        fullWidth
                        onChange={e => setPhone(e.target.value)}

                    />
                    <TextField
                        autoFocus
                        margin="dense"
                        id="emaitl"
                        label="Title"
                        // type="email"
                        fullWidth
                        onChange={e => setTitle(e.target.value)}

                    />


                    <TextField
                        autoFocus
                        margin="dense"
                        id="emaitl"
                        label="Company"
                        // type="email"
                        fullWidth
                        onChange={e => setCompany(e.target.value)}

                    />


                </DialogContent>
                <DialogActions>

                    <Button onClick={handleSubmit} color="primary">
                        Hire Now
                    </Button>


                </DialogActions>
            </Dialog>

        </>
    );
}

export default InputForm;